'use client';

import React from 'react';
import PropTypes from 'prop-types';

SearchList.propTypes = {
    results: PropTypes.array.isRequired,
    curTab: PropTypes.string,
    onSelect: PropTypes.func,
    selectedClinic: PropTypes.string,
};

export default function SearchList({ results, curTab, onSelect, selectedClinic }) {
    const onBookClick = (clinic) => {
        document.dispatchEvent(new CustomEvent('select-clinic', {detail: clinic}));
        onSelect(clinic); 
    };

    return (
        <div className={`searchListWrapper ${curTab == 'list' ? 'searchListWrapper--active' : ''}`}>
            {results.length > 0 ? (
                <div className="searchListWrapper__inner">
                    {results.map((clinic) => {
                        return (<div
                            key={clinic.id}
                            className={`searchListWrapper__result ${clinic.bookable ? '' : 'u-hidden'}`}
                        >
                            <input type="radio" name="clinic" value={clinic.id} onChange={() => onBookClick(clinic)} className="searchListWrapper__radio" id={clinic.id} checked={selectedClinic == clinic.id} />
                            <label className="u-block" htmlFor={clinic.id}>
                                <h3
                                    className="searchListWrapper__title"
                                    dangerouslySetInnerHTML={{
                                        __html: clinic.title,
                                    }}
                                ></h3>
                                <address
                                    className="searchListWrapper__address"
                                    dangerouslySetInnerHTML={{
                                        __html: clinic.address.replace(
                                            /[<]br[^>]*[>]/gi,
                                            ''
                                        ),
                                    }}
                                ></address>
                                <p className="searchListWrapper__distance">
                                    Distance: {clinic.distance}mi (approx.)
                                </p>
                            </label>
                        </div>)
                    })}
                </div>
            ) : (
                <p className="searchListWrapper__error">No clinics found</p>
            )}
        </div>
    );
}
